import http, { API_CORE } from '../../http';

export default function AnalyticsServiceV2() {
  const getDashboardAnalytics = async (params = {}) => {
    const response = await http(API_CORE).get('/v2/analytics/dashboard', { params });
    return response.data;
  };

  return {
    getDashboardAnalytics,
  };
}
